(function($) {
    $(document).ready(function(){

        $('p.close').on('click', function(){
            $('.multiple-shipping-modal').toggleClass('show');
            //document.cookie = "multiShip = True; path=/";
        });

        $('button.single-address').on('click', function(){
            $('.multiple-shipping-modal').toggleClass('show');
            //document.cookie = "multiShip = False; path=/";
        });

        $('a.multiple-address').on('click', function(){
            document.cookie = "multiShip = True; path=/";
        });

    });
})(jQuery); // Fully reference jQuery after this point.
